// Resolves once an element matching `selector` exists in the DOM and is visible,
// or rejects after `timeoutMs`. Used by the guided tour to wait for anchors that
// mount asynchronously (route transitions, Apollo queries, modal animations).
export function waitForElement(
  selector: string,
  timeoutMs = 4000
): Promise<HTMLElement> {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(selector) as HTMLElement | null;
    if (existing && isVisible(existing)) {
      resolve(existing);
      return;
    }

    let done = false;
    const finish = (el: HTMLElement) => {
      if (done) return;
      done = true;
      clearTimeout(timer);
      observer.disconnect();
      resolve(el);
    };

    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector) as HTMLElement | null;
      if (el && isVisible(el)) finish(el);
    });

    const timer = setTimeout(() => {
      if (done) return;
      done = true;
      observer.disconnect();
      reject(new Error(`waitForElement: "${selector}" not found within ${timeoutMs}ms`));
    }, timeoutMs);

    observer.observe(document.body, { childList: true, subtree: true });
  });
}

function isVisible(el: HTMLElement): boolean {
  return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
}
